import type { DeepPartial } from '@luna/utils-ts';

import type { Export } from '../../types/Export';

export const exportATFeatureConfig: DeepPartial<Export> = {
    disableFieldsByFormat: {
        ALL: {
            titles: ['subSecAccountName', 'capitalPlan', 'capitalGainTax'],
            type: ['subSecAccountName', 'capitalPlan', 'capitalGainTax'],
            subSecAccounts: ['performance', 'performancePercent', 'totalIncome', 'fees'],
            sections: ['performance', 'performancePercent', 'totalIncome', 'fees'],
        },
    },
    extraFields: [
        { key: 'fees' },
        { key: 'subSecAccountName' },
        { key: 'capitalPlan' },
        { key: 'capitalGainTax' },
    ],
};
